<template>

    <div class="list__item"
         :class="{'list__item__active': item.checked}">

        <div class="list__item__left">
            <img
                :src="item.checked ? '/img/newsletters-v2/checkbox-2-on.svg' : '/img/newsletters-v2/checkbox-2-off.svg'"
                class="list__item__left__img">
        </div>

        <div class="list__item__middle">
            <p>
                <span class="list__item__middle__text" :data-highlight="item.notSeen ? ENUM.HIGHLIGHT.NOT_SEEN : ''">
                    <div class="list__item__middle__not-seen" v-show="item.notSeen"></div>
                    <img class="list__item__middle__later" src="/img/newsletters-v2/later-blue.svg" v-show="item.type === ENUM.NEWSLETTERS.CATEGORIES.LATER">
                    <span class="text-lMedium">{{ item.name }}</span>
                    <span class="text-baseRegular list__item__middle__count">{{ item.count }}</span>
                </span>
            </p>
            <p class="ellipsis-text text-baseRegular color__moon">{{ item.sender }}</p>
        </div>
        <div class="list__item__right">
            <span class="list__item__right__spoum" v-if="Subscription.isSpoum(item)">{{ $t('spam') }}</span>
            <circle-progress-bar v-else :percent="item.openRate" :size="40" :text="true"></circle-progress-bar>
        </div>

    </div>

</template>

<script>
import ENUM from '@/assets/ENUM'

import Subscription from '@/helpers/subscription'

import CircleProgressBar from '../../components/newsletters-v2/CircleProgressBar'

export default {

    name: 'list-item-mobile',

    components: {
        CircleProgressBar
    },

    props: {
        item: {
            type: Object,
            required: true
        }
    },


    computed: {

        ENUM() {
            return ENUM
        },

        Subscription() {
            return Subscription
        }
    },

    data() {
        return {}
    },
    methods: {

        action(enumAction) {
            const senders = this.localList
                .filter(item => item.checked)
            this.$emit('action', {enumAction, senders})
        },
    }
}
</script>

<style lang="scss" scoped>

.list {
    &__item {
        height: 94px;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: solid 1px #e7e7e8;
        margin-bottom: 1px;
        background-color: $white;

        &__active {
            background-color: #e0f1fc;
        }

        &__left {
            width: 52px;
            padding: 16px;

            &__img {
                width: 20px;
                object-fit: contain;

                &:lang(ar-sa) {
                    transform: scaleX(-1);
                }
            }
        }

        &__middle {
            display: flex;
            flex: 1;
            flex-direction: column;
            text-align: start;
            overflow: hidden;

            &__not-seen {
                width: 8px;
                height: 8px;
                border-radius: 8px;
                background-color: $aquamarine;
                margin-right: 8px;
                &:lang(ar-sa) {
                    margin-right: 0;
                    margin-left: 8px;
                }
            }

            &__later {
                width: 16px;
                object-fit: contain;
                margin-right: 8px;
                &:lang(ar-sa) {
                    margin-right: 0;
                    margin-left: 8px;
                }
            }

            &__count {
                padding: 2px 8px;
                border-radius: 16px;
                background: $timberwolf;
                margin-left: 8px;
                font-size: 12px;
                font-weight: 500;
                line-height: 16px;
            }

            > p {
                display: flex;
                flex-direction: row;
            }

            &__text {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 0 4px 0 0;

                &:lang(ar-sa) {
                    margin: 0 0 0 4px;
                }
            }
        }

        &__right {
            width: min-content;
            padding: 16px;

            &__spoum {
                padding: 2px 8px;
                border-radius: 16px;
                background: #FAEAF1;
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                line-height: 16px;
                color: $raspberry;
            }
        }
    }
}

</style>
